import React from 'react';
import EmptyBoxSvg from "../../svg/EmptyBoxSvg";

const ErrorOutline = ({ color = "white", className }) => {
  return (

    <svg  className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.33301 9.99992H8.66634V11.3333H7.33301V9.99992ZM7.33301 4.66659H8.66634V8.66659H7.33301V4.66659ZM7.99301 1.33325C4.31301 1.33325 1.33301 4.31992 1.33301 7.99992C1.33301 11.6799 4.31301 14.6666 7.99301 14.6666C11.6797 14.6666 14.6663 11.6799 14.6663 7.99992C14.6663 4.31992 11.6797 1.33325 7.99301 1.33325ZM7.99967 13.3333C5.05301 13.3333 2.66634 10.9466 2.66634 7.99992C2.66634 5.05325 5.05301 2.66659 7.99967 2.66659C10.9463 2.66659 13.333 5.05325 13.333 7.99992C13.333 10.9466 10.9463 13.3333 7.99967 13.3333Z" fill="#FFA800" />
    </svg>


  );
};
export default ErrorOutline